import { render, staticRenderFns } from "./AvatarGroupCard.vue?vue&type=template&id=1f63119a&scoped=true&"
import script from "./AvatarGroupCard.vue?vue&type=script&lang=js&"
export * from "./AvatarGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGroupCard.vue?vue&type=style&index=0&id=1f63119a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f63119a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
